import React, { FC } from 'react';
import { FlexGrid } from '../../../../../components/FlexGrid';
import { MovingGradient } from '../../../../../components/MovingGradient';

export const IssueDetailAddressSkeleton: FC = () => {
	return (
		<FlexGrid
			column
			gap='tiny'
		>
			<MovingGradient
				height='10px'
				width='80px'
				borderRadius='8px'
			/>
			<MovingGradient
				height='10px'
				width='120px'
				borderRadius='8px'
			/>
			<MovingGradient
				height='10px'
				width='140px'
				borderRadius='8px'
			/>
			<MovingGradient
				height='10px'
				width='100px'
				borderRadius='8px'
			/>
			<MovingGradient
				height='10px'
				width='250px'
				borderRadius='8px'
			/>
		</FlexGrid>
	);
};
